export type ShareOutcome = 'shared' | 'copied' | 'cancelled' | 'failed';

export async function shareOrCopy(data: {
  title?: string;
  text?: string;
  url?: string;
}): Promise<ShareOutcome> {
  if (navigator.share) {
    try {
      await navigator.share(data);
      return 'shared';
    } catch (e: any) {
      if (e?.name === 'AbortError') return 'cancelled';
    }
  }
  const content = [data.text, data.url].filter(Boolean).join('\n');
  try {
    await navigator.clipboard.writeText(content);
    return 'copied';
  } catch {
    return 'failed';
  }
}

export function todayIso(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function daysFromToday(date: string | Date | null | undefined): number | null {
  if (!date) return null;
  const target = new Date(date);
  if (isNaN(target.getTime())) return null;
  const a = new Date();
  a.setHours(0, 0, 0, 0);
  const b = new Date(target.getFullYear(), target.getMonth(), target.getDate());
  return Math.round((b.getTime() - a.getTime()) / 86400000);
}
